// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__2PfoM","range":"MonthRangeSwitch_range__kFPhS","disabled":"MonthRangeSwitch_disabled__1-ELS"};